export const fetchBlock = async (sessionId: string, fromDate: string, toDate: string) => {
	try {
		const formData = new FormData();

		formData.append('method', 'block_user');
		formData.append('session_id', sessionId);
		formData.append('start_date', fromDate);
		formData.append('end_date', toDate);

		const API = import.meta.env.VITE_API_BASE_URL;
		const url = `${API}/carbon`;

		const response = await fetch(url, {
			method: 'POST',
			body: formData,
		});

		if (!response.ok) {
			throw new Error(`HTTP error! status: ${response.status}`);
		}

		const data = await response.json();

		return data;
	} catch (error) {
		console.error('Fetch error:', error);
		throw error;
	}
};
